<div
    *ngIf="showPlaceDetails && placeIds && placeIds.length > 0"
    id="{{ element.id }}"
    [ngClass]="getComponentCssClasses(element.id)"
    [attr.data-e2e]="'place-details-' + element.id"
    class="places-ui-kit-container"
>
    <div class="places-layout">
        <div class="places-list">
            <div class="google-business-listing page-break-inside" *ngFor="let placeId of placeIds">
                <gmp-place-details-compact orientation="horizontal" [ngStyle]="cssVariables">
                    <gmp-place-details-place-request [place]="placeId"></gmp-place-details-place-request>
                    <gmp-place-content-config>
                        <gmp-place-rating></gmp-place-rating>
                        <gmp-place-type></gmp-place-type>
                        <gmp-place-opening-hours></gmp-place-opening-hours>
                        <gmp-place-website></gmp-place-website>
                        <gmp-place-phone-number></gmp-place-phone-number>
                        <gmp-place-address></gmp-place-address>
                        <gmp-place-open-now-status></gmp-place-open-now-status>
                    </gmp-place-content-config>
                </gmp-place-details-compact>
            </div>
        </div>

        <!-- Google Maps integration -->
        <div class="places-map">
            <div class="places-map-container" *ngIf="showPlaceDetails"></div>
        </div>
    </div>
</div>